import { Check, X } from "lucide-react";
import FadeUp from "@/components/landing/FadeUp";
import { WHY_US } from "./content";
import { Card, SectionHeading } from "./Primitives";

const Column = ({ title, items, positive, testId }) => (
    <Card
        data-testid={testId}
        className={
            positive
                ? "p-7 md:p-9 border-brand-blue/30 bg-white shadow-[0_30px_80px_-50px_rgba(45,91,255,0.45)] ring-1 ring-brand-blue/10"
                : "p-7 md:p-9 bg-hire-bg"
        }
    >
        <div className="flex items-center gap-3">
            <span
                className={`h-8 w-8 rounded-lg grid place-items-center ${
                    positive ? "bg-brand-blue text-white" : "bg-white border border-hire-line text-hire-muted"
                }`}
            >
                {positive ? <Check className="h-4 w-4" strokeWidth={3} /> : <X className="h-4 w-4" />}
            </span>
            <h3 className="text-lg font-semibold text-hire-ink">{title}</h3>
        </div>
        <ul className="mt-7 space-y-4">
            {items.map((it) => (
                <li key={it} className="flex items-start gap-3 text-[15px] leading-relaxed">
                    {positive ? (
                        <Check className="mt-1 h-4 w-4 shrink-0 text-brand-blue" strokeWidth={2.5} />
                    ) : (
                        <X className="mt-1 h-4 w-4 shrink-0 text-hire-muted/60" />
                    )}
                    <span className={positive ? "text-hire-ink" : "text-hire-muted"}>{it}</span>
                </li>
            ))}
        </ul>
    </Card>
);

export const WhyUs = () => (
    <section id="why-us" data-testid="why-us-section" className="section-pad bg-white border-t border-hire-line">
        <div className="container-page">
            <SectionHeading
                eyebrow="Why AV Consultation instead of job sites?"
                title={WHY_US.heading}
                sub={WHY_US.sub}
                testId="why-us-heading"
            />
            <div className="mt-14 md:mt-16 grid md:grid-cols-2 gap-5 md:gap-6 items-start">
                <FadeUp>
                    <Column title={WHY_US.jobSites.title} items={WHY_US.jobSites.items} testId="why-us-job-sites" />
                </FadeUp>
                <FadeUp delay={0.1}>
                    <Column title={WHY_US.avc.title} items={WHY_US.avc.items} positive testId="why-us-avc" />
                </FadeUp>
            </div>
            <FadeUp delay={0.1}>
                <p
                    data-testid="why-us-closing"
                    className="mt-12 md:mt-16 max-w-3xl text-xl md:text-2xl font-semibold text-hire-ink leading-snug text-balance"
                >
                    {WHY_US.closing}
                </p>
            </FadeUp>
        </div>
    </section>
);

export default WhyUs;
